class ProductGallerySlider extends HTMLElement {
  constructor() {
    super();

    let options = {
      imagesLoaded: true,
      contain: true,
      prevNextButtons: false,
      fade: true,
      wrapAround: true
    };

    const slider = new Flickity(this, options);

    slider.on("change", (selected_index) => {
      play_and_pause_videos(selected_index);
    });

    document.addEventListener("productgallerythumbnails:click", (event) => {
      slider.select(event.detail.index);
    });

    document.addEventListener("productformvariants:change", (event) => {
      slider.cells.forEach((cell, index) => {
        if (cell.element.dataset.variantId.includes(event.detail.variant.id)) {
          slider.select(index);
        }
      });
    });

    if (Theme.URLParams.has("variant")) {
      slider.cells.forEach((cell, index) => {
        if (cell.element.dataset.variantId.includes(Theme.URLParams.get("variant"))) {
          slider.select(index);
        }
      });
    }

    function play_and_pause_videos(selected_index) {
      slider.getCellElements().forEach((element, element_index) => {
        const video = element.querySelector("video");

        if (!video) {
          return;
        }

        if (selected_index == element_index) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }
}

customElements.define("product-gallery-slider", ProductGallerySlider);

class ProductGalleryThumbnails extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();

      const element = event.target.closest("a");

      this.querySelectorAll("a").forEach((thumb) => {
        thumb.classList.remove("is-active");
      });

      element.classList.add("is-active");

      document.dispatchEvent(new CustomEvent("productgallerythumbnails:click", {
        detail: {
          index: element.dataset.index
        }
      }));
    });
  }
}

customElements.define("product-gallery-thumbnails", ProductGalleryThumbnails);

class ProductGalleryLightbox extends Theme.Component {
  constructor() {
    super();
    this.events();
    this.lightbox = this.querySelector('.product-gallery-lightbox-overlay');
    document.body.appendChild(this);
    document.addEventListener('openlightbox:click', () => {
      this.openLightbox();
    });
  }

  openLightbox() {
    document.body.appendChild(this);
    this.events();
    this.lightbox.classList.add('open');
    document.body.classList.add('no-scroll');
  }

  closeLightbox() {
    this.lightbox.classList.remove('open');
    document.body.classList.remove('no-scroll');
  }
}

customElements.define("product-gallery-lightbox", ProductGalleryLightbox);